<template>
  <div >
    <div class="out_box pc_table_box"  >
      <div class="list info-list">
        {{$t('total_pending_withdrawal_share')}} :
        <span style="display: block;word-break:break-all;white-space: break-spaces;">{{totalShare}}</span>
      </div>
      <div class="list info-list">
        {{$t('share_value')}} :
        <span style="display: block;word-break:break-all;white-space: break-spaces;">{{sharePrice}}</span>
      </div>
      <div class="list info-list" >
        {{$t('total_pending_withdrawal_assets')}} :
        <span style="display: block;word-break:break-all;white-space: break-spaces;">{{totalAmount}}</span>
      </div>
      <div class="list info-list" >
        {{$t('available_balance')}} :
        <span style="display: block;word-break:break-all;white-space: break-spaces;">{{available}}</span>
      </div>

    </div>
    <div class="data_content mobile_table_box" style="margin-top: 20px">
      <div class="row">
        <div class="item">
          <div class="title">{{$t('total_pending_withdrawal_share')}}</div>
          <div class="value">{{totalShare}}</div>
        </div>
        <div class="item">
          <div class="title right">{{$t('share_value')}}</div>
          <div class="value right">{{sharePrice}}</div>
        </div>
      </div>
      <div class="row" style="margin-top: 16px">
        <div class="item">
          <div class="title">{{$t('total_pending_withdrawal_assets')}}</div>
          <div class="value">{{totalAmount}}</div>
        </div>
        <div class="item">
          <div class="title right">{{$t('available_balance')}}</div>
          <div class="value right">{{available}}</div>
        </div>
      </div>
    </div>
    <el-table  class="table_box pc_table_box" :data="tableData7" style="width: 100%" v-loading="loading"
               element-loading-background="rgba(0, 0, 0, 0.8)"
               ref="table"
               @selection-change="selectChange"
               max-height="300"
               :row-style="{ height: '59px' }"
    >
      <el-table-column type="selection" width="55" align="left"></el-table-column>
      <el-table-column prop="id" :label="$t('order_id')" width="80px"></el-table-column>
      <el-table-column prop="address" :label="$t('address')" width="380px"></el-table-column>
      <el-table-column prop="share" :label="$t('transfer_out')" width="140px"></el-table-column>
      <el-table-column prop="countdown" :label="$t('lock_countdown')" width="140px">
      </el-table-column>
      <el-table-column :label="$t('instant_withdrawal')" align="center">
        <template slot-scope="scope">
          <div class="operate_box" >
            <div class="operate_2" style="padding: 0 0;" @click="agree(scope.row)"><span style="color: #A5D63F;">{{$t('agree')}}</span></div>
          </div>
        </template>
      </el-table-column>

    </el-table>

    <div class="mobile_table_box withdrawal_list" v-loading="loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="item" v-for="(item,index) in tableData7" :key="index">
        <el-checkbox v-model="item.isAgree" @change="selectMItem($event,item)" />
        <div class="item_info">
          <div>
            <div class="title">{{$t('copy_trading_address')}}</div>
            <div class="value">{{item.address}}</div>
          </div>
          <div>
            <div class="title right">{{$t('transfer_amount')}}</div>
            <div class="value right">{{item.share}}</div>
          </div>
          <div>
            <div class="title">{{$t('lock_countdown')}}</div>
            <div class="value">{{item.countdown}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="agree_box">
      <div class="agree_left"><img :src="this.selectAll.length>0?require('../assets/imgs/selected.svg'):require('../assets/imgs/unselected.svg')" class="select"/><span class="agree_select_note">{{$t('selected')}}{{this.selectAll.length}}{{$t('item')}}</span> <span class="agree_cancel" @click="cancelAll">{{$t("cancel")}}</span></div>
      <div class="agree_right" @click="agreeAll">
        {{$t('batch_agree')}}
      </div>
    </div>
    <div class="agree_box_mobile">
      <div class="agree_item">
        <div class="agree_item_1">
          <img :src="this.selectAll.length>0?require('../assets/imgs/selected.svg'):require('../assets/imgs/unselected.svg')" class="select"/>
          <span class="agree_select_note">{{$t('selected')}}{{this.selectAll.length}}{{$t('item')}}</span>
        </div>
        <div>
          <el-checkbox :label="$t('select_all')" v-model="selectAllValue" @change="selectAgreeAll" />
        </div>
      </div>
      <div class="agree_action">
        <div class="agree_a" @click="agreeAll">{{$t('agree')}}</div>
        <div class="agree_c" @click="selectAgreeAll(false);selectAllValue=false;">{{$t("cancel")}}</div>
      </div>
    </div>
    <el-dialog :modal="false" :title="inputType==0?$t('transfer_in'):$t('transfer_out')" :visible.sync="dialogVisible" >
      <div>
        <div class="dialog_list">
          <div class="left">{{$t('currency_address_label')}}</div>
          <div class="right">{{this.up.address}}</div>
        </div>
        <div class="dialog_list">
          <div class="left">{{$t('currency_name_label')}}</div>
          <div class="right">{{this.up.name}}</div>
        </div>
        <div class="dialog_list">
          <div class="left">{{$t('transfer_quantity')}}</div>
          <div class="right">{{this.num}}</div>
        </div>
      </div>
      <span slot="footer" class="dialog_footer_box">
        <el-button style="background: #C6FE61;color: #181A20" type="primary" @click="ok1()">{{$t('confirm')}}</el-button>
        <el-button class="cancel_box" @click="dialogVisible = false">{{$t('cancel')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :modal="false" :close-on-click-modal="false" :title="inputType==0?$t('transfer_in'):$t('transfer_out')" :visible.sync="inputDialog" >
      <div v-if="inputType==1" style="color: #EF454AFF;font-weight: 500;margin-bottom: 11px;">{{$t('estimatedTransferableQuantity')}}：{{canTransOut}}</div>
      <div>
        <div class="dialog_list">
          <div class="open-amount-container">
            <input type="number" min="0" class="open-amount-input"  v-model="num" value="0">
            <span class="btc-label" @click="max">{{$t('maximum')}}</span>
          </div>
        </div>

      </div>
      <span slot="footer" class="dialog_footer_box">
        <el-button style="background: #C6FE61;color: #181A20" type="primary" @click="ok2()">{{$t('confirm')}}</el-button>
        <el-button class="cancel_box" @click="inputDialog = false">{{$t('cancel')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog :modal="false" style="margin-top: 24vh" :show-close="false" :visible.sync="showRevert" >
      <div class="text_box" style="color: white">
        {{this.agreeType==0?$t('confirm_agree'):$t('confirm_batch_agree')}} {{this.agreeType==0?this.selectItem?.address:this.selectAllAddress}} {{$t('withdrawal_request')}}？
      </div>
      <span slot="footer" class="dialog_footer_box">
        <el-button style="background: #C6FE61;color: #181A20" type="primary" @click="doWithdrawal">{{$t("confirm")}}</el-button>
        <el-button class="cancel_box" @click="showRevert = false">{{$t("cancel")}}</el-button>
      </span>
    </el-dialog>

  </div>


</template>

<script>
import {getTransData} from "../service/queryService";
import {
  createErc20AndSend,
  createLeadingContractAndCall,
  createLeadingContractAndSend, createPerpOptionAndCall,
  estimateAndSend,
  getErc20Info, getGasReward, getSelectTokenInfo
} from "../utils/contract";
import {getAccount, getAccountWithDot, getChainId, isOld, sleep} from "../utils/wallet";
import {Contract, Method, Underling} from "../config/const";
import {transBig2number, transNumber2Big, transTime2Date} from "../utils/functions";
import {getLastPrice} from "../service/priceService";
import {ethers} from "ethers";
import config from "../config/config";
import {BigNumber} from "ethers";
import {getDotAddress} from "../utils/strings";
import {MESSAGE, registerMessage, removeMessage} from "../utils/message";

export default {
  name: "activate7",
  props:{
    contractAddress:"",
    token:""
  },
  data(){
    return{
      tableData7: [],
      currentPage: 1,
      up:{
        input1:'',
        inputDot:'',
        name:'',
        address:'',
        price:'0',
        priceValue:'0',
        decimals:6,
        asset:"0",
        origin:BigNumber.from(0)
      },
      token2:"",
      loading:false,
      dialogVisible: false,
      inputType:0,
      num:"",
      inputDialog:false,
      priceRate:"0",
      canTransOut:"0",
      shareAsset:"",
      optionAddress:"",
      showRevert:false,
      selectItem:null,
      totalShare:"",
      totalAmount:"",
      sharePrice:"",
      available:"",
      selectAll:[],
      agreeType:0,
      selectAllAddress:"",
      selectImage:require("../assets/imgs/unselected.svg"),
      selectAllValue:false,
      releaseTime:2*86400
    }
  },
  mounted() {
    registerMessage(this.updateMessage)
  },
  unmounted(){
    removeMessage(this.updateMessage)
  },
  created() {
    // this.init();
  },

  methods: {
    prevClick(e){
      console.log(e)
      this.currentPage--
      this.getData()
    },
    nextClick(){
      this.currentPage++
      this.getData()
    },
    selectChange(val){
      this.selectAll=val;
      for(let i in val){
        this.selectAllAddress+=val[i].address+" ";
      }
    },
    async doWithdrawal(){
      this.showRevert=false;
      let ids=[];
      if(this.agreeType==0){
        ids.push(this.selectItem.id)
      }else if(this.agreeType==1){
        for(let i in this.selectAll){
          ids.push(this.selectAll[i].id);
        }
      }
      if(ids.length==0){
        return;
      }

      let chainId=await getChainId();
      let price=await getLastPrice();
      // let tigger=await getGasReward(this.token,Underling.ETH);
      await createLeadingContractAndSend(this.contractAddress,Method.handleWithdrawItems,[ids,false,[Underling.BTC,Underling.ETH],[ethers.utils.arrayify(price[Underling.BTC].hex),ethers.utils.arrayify(price[Underling.ETH].hex)]],config[chainId].verifyValue)
      this.init()
    },
    agree(row){
      this.selectItem=row;
      this.agreeType=0;
      this.showRevert=true;
    },
    agreeAll(){
      if(this.selectAll.length==0){
        this.$message.error(this.$t('select_agreed_order'))
        return;
      }
      this.agreeType=1;
      this.showRevert=true;
    },
    async getData(){
      if(!this.contractAddress){
        return;
      }
      let tokenInfo=await getSelectTokenInfo(this.token);
      if(!tokenInfo){
        return;
      }

      let allData=await createLeadingContractAndCall(this.contractAddress,Method.getWithdrawItems,this.contractAddress)
      let data=[];
      let totalShare=BigNumber.from(0);
      let totalAmount=BigNumber.from(0);
      for(let i in allData){
        let item=allData[i];
        data.push({
          id:item.withdrawID.toString(),
          address:item.user,
          share:transBig2number(item.withdrawShare.toString()),
          time:item.withdrawTime.toString(),
          countdown:"",
          isAgree:false
        })
        totalShare=totalShare.add(item.withdrawShare)
        totalAmount=totalAmount.add(item.withdrawAmount)

      }
      this.totalShare=transBig2number(totalShare)
      this.tableData7=data;

      let price=await getLastPrice()
      let priceBTC=transBig2number(price[Underling.BTC].price,price[Underling.BTC].decimal,6);
      let priceETH=transBig2number(price[Underling.ETH].price,price[Underling.ETH].decimal,6);

      let priceBtcNum=transNumber2Big(priceBTC);
      let priceEthNum=transNumber2Big(priceETH);
      //获取总资产
      let totalBalance=await createLeadingContractAndCall(this.contractAddress,Method.getTotalBalance,[Underling.BTC,Underling.ETH],[priceBtcNum,priceEthNum]);
      let allShare=await createLeadingContractAndCall(this.contractAddress,Method.totalShare);
      let sharePrice=BigNumber.from(0);
      if(allShare.gt(BigNumber.from(0))){
        sharePrice=totalBalance.assetAmount.mul(BigNumber.from(10000)).div(allShare)
      }
      this.sharePrice=(parseFloat(sharePrice.toString())/10000).toFixed(4);
      this.totalAmount=transBig2number(sharePrice.mul(totalShare),22,2)

      let selectToken=await getSelectTokenInfo(this.token)
      this.optionAddress=selectToken.perpetual

      let accountInfo=await createPerpOptionAndCall(this.optionAddress,Method.getAccountInfo,this.token,this.contractAddress)
      if(totalBalance.gainLoss){
        this.available=transBig2number(accountInfo.availableAmount)
      }else{
        this.available=transBig2number(accountInfo.availableAmount.sub(totalBalance.profit))
      }

      let auditWithdrawPeriod=await createLeadingContractAndCall(this.contractAddress,Method.auditWithdrawPeriod)
      this.releaseTime=parseInt(auditWithdrawPeriod.toString())

    },
    cancelAll(){
      this.$refs.table.clearSelection();
      this.selectAllAddress="";
    },
    async countDown(){
      if(!this.tableData7 || this.tableData7.length==0){
        return;
      }
        for(let i in this.tableData7){
          let item=this.tableData7[i];
          let endTime=parseInt(item.time)+this.releaseTime;
          let sub=endTime-parseInt(new Date().getTime()/1000)
          if(sub<=0){
            this.tableData7[i].countdown="--";
            continue;
          }
          let subDay = Math.floor(sub / 86400);
          let subHour = Math.floor((sub % 86400) / 3600);
          let subMin = Math.floor((sub % 3600) / 60);
          let subSec = Math.floor((sub % 60));

          if (subHour < 10) {
            subHour = "0" + subHour;
          }
          if (subMin < 10) {
            subMin = "0" + subMin;
          }
          if (subSec < 10) {
            subSec = "0" + subSec;
          }
          this.tableData7[i].countdown=`${subDay}D:${subHour}:${subMin}:${subSec}`
        }
    },
    async initData(){

    },


    async init(){
      this.loading=true;
      await this.initData();
      await this.getData();
      setInterval(this.countDown,1000);
      this.loading=false;
    },
    ok1(){
      if(this.inputType==0){
        this.deposit()
      }else{
        this.withdrawal()
      }
      this.dialogVisible=false;
    },
    async showDialog(type){
      this.inputType=type;
      this.inputDialog=true;
    },
    ok2(){
      this.inputDialog=false;
      this.dialogVisible=true;
    },
    max(){
      if(this.inputType==0){
        this.num=this.up.price;
      }else{
        this.num=this.up.asset;
      }
    },
    selectMItem(value,params){
      if(value){
        this.selectAll.push(params)
      }else{
        for(let i in this.selectAll){
          if(this.selectAll[i].id==params.id){
            this.selectAll.splice(i,1);
          }
        }
      }
      for(let i in this.selectAll){
        this.selectAllAddress+=this.selectAll[i].address+" ";
      }
    },
    selectAgreeAll(value){
      if(value){
        this.selectAll=this.tableData7;
      }else{
        this.selectAll=[];
      }
      for(let i in this.tableData7){
        this.tableData7[i].isAgree=value;
      }
    },
    updateMessage(msg,data){
      if(msg==MESSAGE.WITHDRAWAL){
        this.init()
      }
    }
  },
  watch:{
    num(val){
      if(val<0){
        this.num=0;
      }
      if(!val){
        this.canTransOut="0";
      }else{
        this.canTransOut=(parseFloat(val)*parseFloat(this.priceRate)).toFixed(2);
      }
    },

  },

}
</script>

<style src="../assets/list.scss" lang="scss" scoped></style>
<style src="../assets/css/index.scss" lang="scss" scoped></style>
<style src="../assets/windows.scss" lang="scss" scoped></style>

<style lang="scss" scoped>
.out_box{
  color: #A6A6A6;
  font-weight: 500;

  span{
    color: #ffffff;
  }
}
.select{
  width: 20px;
}

.el-input__inner{
  padding: 0px !important;
  width: 180px !important;
}
.left{
  flex: revert;
}
::v-deep .el-dialog__title{
  font-weight: 400!important;
  font-size: 18px;
  letter-spacing: 0px;
  line-height: 21.1px;
  color: rgba(234, 236, 239, 1);
}
::v-deep .el-dialog__footer{
  display: flex!important;
  width: 100% !important;
  .el-button{
    flex: 1;
    width: calc(100% - 10px);
  }
}
.open-amount-container {
  display: flex;
  height: 40px;
  opacity: 1;
  border-radius: 6px;
  background: #181A20;
  align-items: center;
  border: 1px solid #EAECEF33;
  font-size: 12px;
  padding-right: 13px;

  .open-amount-input {
    border: none;
    padding: 8px;
    color: #EAECEF;
    background-color: transparent;
    outline: none;
    flex: 1;
  }
}

.info-list{
  flex: revert !important;
  margin-right: 95px !important;
}

.btc-label {
  color: #EAECEF;
  margin-left: 5px;
  flex: 0 0 auto;
  cursor: pointer;
}

::v-deep .el-dialog{
  width: 380px !important;
}

.agree_box{
  display: flex;
  justify-content: space-between;
  margin-top: 28px;
  align-items: center;
  margin-bottom: 300px;
}
.agree_left{
  display: flex;
  align-items: center;
}
.agree_select_note{
  font-size: 14px;
  color: rgba(198, 254, 97, 1);
  font-weight: 500;
  margin-left: 12px;
}
.agree_cancel{
  margin-left: 26px;
  font-size: 14px;
  font-weight: 500;
  color:rgba(166, 166, 166, 1);
  cursor: pointer;
}
.agree_right{
  width: 96px;
  height: 32px;
  border-radius: 8px;
  border:1px solid rgba(198, 254, 97, 1);
  color:rgba(198, 254, 97, 1);
  font-size: 14px;
  line-height: 32px;
  text-align: center;
  font-weight: 500;
  cursor: pointer;
}
.agree_box_mobile{
  display: none;
}

@media (max-width: 750px) {
  ::v-deep .el-dialog{
    width: 80% !important;
  }
  .agree_box{
    display: none;
  }
  .agree_box_mobile{
    display: block;
    margin-bottom: 200px;
    .agree_item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 27px;
      margin-right: 27px;
      .agree_item_1{
        display: flex;
        align-items: center;
      }
    }
    .agree_action{
      display: flex;
      margin-left: 15px;
      margin-right: 15px;
      gap: 9px;
      margin-top: 24px;
      .agree_a{
        border-radius: 6px;
        background: rgba(165, 214, 63, 1);
        border-radius: 6px;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 32px;
        color: rgba(0, 0, 0, 1);
        text-align: center;
        height: 32px;
        flex: 1;
      }
      .agree_c{
        border-radius: 6px;
        background: rgba(56, 56, 56, 1);
        border-radius: 6px;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 32px;
        color: rgba(165, 214, 63, 1);
        height: 32px;
        text-align: center;
        flex: 1;
      }
    }
  }
  .withdrawal_info{
    margin-left: 15px;
    margin-right: 15px;
    padding: 17px 20px 17px 20px;
    width: revert !important;
    min-width: revert !important;
    max-width: revert !important;
  }
  .withdrawal_list{
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 20px;
    min-height: 80px;
    .item{
      display: flex;
      align-items: center;
      border-bottom: 0.2px solid rgba(90, 90, 93, 1);
      margin-bottom: 16px;
      gap: 20px;
      .item_info{
        display: grid;
        grid-template-rows: repeat(2, 1fr);  /* 两行，行高平分 */
        grid-template-columns: 2fr 1fr;  /* 两列，列宽平分 */
        row-gap: 18px;
      }
      .title{
        font-size: 11px;
        font-weight: 500;
        letter-spacing: -1px;
        line-height: 15.93px;
        color: rgba(90, 90, 93, 1);
      }
      .value{
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 15.24px;
        color: rgba(234, 236, 239, 1);
        word-break: break-all;
      }
      .right{
        text-align: right;
      }
    }
  }
  .data_content{
    margin-left: 15px;
    margin-right: 15px;
    border: 0.55px solid rgba(56, 56, 56, 1);
    padding: 17px 20px 17px 20px;
    .row{
      display: flex;
      .item{
        flex: 1;
        .title{
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0px;
          color: rgba(166, 166, 166, 1) !important;
        }
        .value{
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0px;
          line-height: 15.24px;
          font-family: "HarmonyOS Sans SC";
          color: rgba(234, 236, 239, 1);
        }
        .right{
          text-align: right;
        }
      }
    }
  }
}

</style>
<style>
.el-table, .el-table__expanded-cell{
  background-color: rgba(24, 26, 32, 1);
}
.el-button--primary{
  border-color: rgb(198, 254, 97)!important;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: rgb(198, 254, 97)!important; /* 选中时的背景色 */
  border-color: rgb(198, 254, 97)!important; /* 选中时的边框色 */
}
.el-checkbox__input.is-checked .el-checkbox__inner::after {
  border-color: #000; /* 勾选符号颜色（可选） */
}
</style>
<style src="../assets/css/mobile.scss" lang="scss" scoped></style>
